import ABKAccordion from "../../../global/components/ABKAccordionAlt";
import { Button } from "@mui/material";
import useFormData from "../hooks/useFormData";
import getAccordionDataChanges from "../utils/GetAccordionDataChanges";
import useClientQuery from "../../../global/queries/useClientQuery";
import usePostChangeQuery from "../../../global/queries/usePostChangeQuery";
import { Client } from "../../../global/interfaces/Client";
import { useQueryClient } from "@tanstack/react-query";
import {
  addressDataValidationSchema,
  companyDataValidationSchema,
} from "../validations";
import { companyDataFormType } from "../validations/companyDataValidationSchema";
import { useSnackbar } from "notistack";
import { addressDataFormType } from "../validations/addressDataValidationSchema";
import * as Yup from "yup";

const DatenForm = () => {
  const { data: client } = useClientQuery();

  const { enqueueSnackbar } = useSnackbar();

  const data = useFormData();

  const changeQuery = usePostChangeQuery();

  const queryClient = useQueryClient();

  const handleSave = async () => {
    try {
      const companyDataForm: companyDataFormType = {
        email: "",
        emailERechnung: "",
        firmenbuchnummer: "",
        name1: "",
        name2: "",
        telefon1: "",
        uidnr: "",
        web: "",
      };

      const addressDataForm: addressDataFormType = {
        strasse: "",
        land: "",
        plz: "",
        ort: "",
      };

      data.companyDataState.forEach((item) => {
        if (item.field && companyDataForm.hasOwnProperty(item.field)) {
          companyDataForm[item.field as keyof companyDataFormType] = item.value
            ? String(item.value)
            : "";
        }
      });

      data.addressDataState.forEach((item) => {
        if (item.field && addressDataForm.hasOwnProperty(item.field)) {
          addressDataForm[item.field as keyof addressDataFormType] = item.value
            ? String(item.value)
            : "";
        }
      });

      await companyDataValidationSchema.validate(companyDataForm, {
        abortEarly: false,
      });
      await addressDataValidationSchema.validate(addressDataForm, {
        abortEarly: false,
      });

      const addressChanges = getAccordionDataChanges(
        data.addressData,
        data.addressDataState,
        client?.suchname || ""
      );
      const companyChanges = getAccordionDataChanges(
        data.companyData,
        data.companyDataState,
        client?.suchname || ""
      );

      const changes = [...addressChanges, ...companyChanges];

      changes.forEach((change) => {
        changeQuery.mutate(change);

        queryClient.setQueryData(["Client"], (oldClientData: Client) => {
          const newClientData = { ...oldClientData };
          if (newClientData.hasOwnProperty(change.feld)) {
            newClientData[change.feld] = change.wertAenderung;
          }
          return newClientData;
        });
      });
    } catch (error) {
      if (error instanceof Yup.ValidationError && error.errors) {
        error.errors.forEach((errorMessage) => {
          enqueueSnackbar(`Validierungsfehler: ${errorMessage}`, {
            variant: "error",
          });
        });
      }
    }
  };

  return (
    <>
      <ABKAccordion
        isInput={true}
        accordionTitle={"Firmendaten"}
        data={data.companyDataState}
        setData={data.setCompanyDataState}
      />
      <ABKAccordion
        isInput={true}
        accordionTitle={"Adressdaten"}
        data={data.addressDataState}
        setData={data.setAddressDataState}
      />
      <Button variant="contained" sx={{ margin: 1.5 }} onClick={handleSave}>
        {changeQuery.isLoading ? "Wird geladen..." : "Speichern"}
      </Button>
    </>
  );
};

export default DatenForm;
